import { Box, Image, Tooltip } from "@chakra-ui/react";
import React from "react";

const SelectedSegmentCard = ({ onDoubleClick, previousSegments, segment }) => {
  const { thumbnailUrl, start, end } = segment;

  if (!thumbnailUrl) {
    return <Box>No thumbnail</Box>;
  }

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    const centiseconds = Math.floor((time % 1) * 100);
    return `${minutes}:${seconds
      .toString()
      .padStart(2, "0")}.${centiseconds.toString().padStart(2, "0")}`;
  };

  // Calculate cumulative start time based on previous segments
  const cumulativeStartTime = previousSegments.reduce((acc, seg) => {
    return acc + (seg.end - seg.start);
  }, 0);

  const segmentDuration = end - start;
  const tooltipContent = (
    <Box>
      <Box>Start: {formatTime(cumulativeStartTime)}</Box>
      <Box>End: {formatTime(cumulativeStartTime + segmentDuration)}</Box>
      <Box>Duration: {formatTime(segmentDuration)}</Box>
    </Box>
  );

  return (
    <Box
      display="inline-flex"
      h="100px"
      onDoubleClick={() => onDoubleClick(segment)}
      w="auto"
    >
      <Tooltip
        closeDelay={100}
        hasArrow
        label={tooltipContent}
        openDelay={300}
        placement="top"
      >
        <Image src={thumbnailUrl} w="100px" />
      </Tooltip>
    </Box>
  );
};

export default SelectedSegmentCard;
